import { BaseProductType, IconicColor, IconicRange, TopLevelMenuCategory } from '../types/productTypes'

export const RangeSortOrderMap: { [key in IconicRange]: number } = {
  Iconic: 0,
  Styl: 1,
  Essence: 2,
  Pro: 3,
  Outdoor: 4,
}
export const ColorSortOrderMap: { [key in IconicColor]: number } = {
  'VW': 0,
  'XW': 1,
  'XB': 2,
  'WY': 3,
  'CY': 4,
  'AN': 5,

  'SV': 6,
  'CE': 7,
  'SH': 8,

  'AW': 9,
  'AG': 10,

  'ProXW': 11,
  'ProBK': 12,
  'ProRD': 13,
  'ProDB': 14,
  'ProGR': 15,

  'OutdoorXW': 16,
  'OutdoorBK': 17,
}
export const BaseProductTypeOrderMap: { [key in BaseProductType]: number } = {
  Socket: 0,
  Switch: 1,
  Other: 2,
}
export const TopLevelSortOrderMap: { [key in TopLevelMenuCategory]: number } = {
  Switch: 0,
  Socket: 1,
  Wiser: 2,
  Outdoor: 3,
  Other: 4,
}